<template lang="html">
    <div class="box-gray-content ml-0">
        <form @submit.prevent="handleSubmit" id="formContact" data-vv-scope="formContact">
            <div class="contenedor-input full-input row-start">
                <label for="">{{ $t('registro.tipo_contacto') }}*</label>
                <template v-if="!!dominiosOrder && !!dominiosOrder.tiposContacoEmpresa">
                    <div class="radio-container" v-for="(tipo, key) in dominiosOrder.tiposContacoEmpresa">
                        <input type="checkbox" :value="tipo[0]" :id="'tipo-contacto-' + tipo[0]"
                            v-model="newuser.tipoContacto" name="tipocontactoUsuario"  v-validate="'required'">
                        <label :for="'tipo-contacto-' + tipo[0]">{{ tipo[1] }}</label>
                    </div>
                </template>
                <span class='error'>{{ errors.first('tipocontactoUsuario') }}</span>
            </div>

            <div class="contenedor-input type-text one-slot -wo-margin">
                <label for="nombre">Nombre*</label>
                <input type="text" name="nombre" v-model="newuser.nombre" v-validate="'required|min:3'">
                <span class='error'>{{ errors.first('nombre') }}</span>
            </div>
            <div class="contenedor-input type-text one-slot -wo-margin">
                <label for="">Apellidos*</label>
                <input type="text" name="apellidos" v-model="newuser.apellidos" v-validate="'required|min:3'">
                <span class='error'>{{ errors.first('apellidos') }}</span>
            </div>
            <div class="contenedor-input type-text one-slot">
                <label for="dni">DNI/NIE/Pasaporte*</label>
                <input type="text" name="dni" v-model="newuser.nif" v-validate="{
                    required: true
                }">
                <span class='error'>{{ errors.first('dni') }}</span>
            </div>
            <div class="contenedor-input type-text one-slot -wo-margin">
                <label for="">Cargo*</label>
                <input type="text" name="cargo" v-model="newuser.puesto" v-validate="'required|min:3'">
                <span class='error'>{{ errors.first('cargo') }}</span>
            </div>
            <div class="contenedor-input one-slot -wo-margin">
                <label for="email">{{ $t('registro.email') }}*</label>
                <input :disabled="isEdition" type="text" name="email" v-model="newuser.email" v-validate="'required|email'">
                <span class='error'>{{ errors.first('email') }}</span>
            </div>
            <div class="contenedor-input type-text one-slot -wo-margin">
                <label for="telefono">Teléfono*</label>
                <input type="text" name="telefono" v-model="newuser.telefono1"
                    v-validate="'required|max:14|min:9|integer'">
                <span class='error'>{{ errors.first('telefono') }}</span>
            </div>
            <div class="contenedor-input type-text one-slot -wo-margin">
                <label for="">Departamento</label>
                <input type="text" name="departamento" v-model="newuser.departamento">
                <span class='error'>{{ errors.first('departamento') }}</span>
            </div>
            <div class="contenedor-input type-text one-slot -wo-margin">
                <label for="">Titulación</label>
                <input type="text" name="titulacion" v-model="newuser.titulacion">
                <span class='error'>{{ errors.first('titulacion') }}</span>
            </div>
            <div class="contenedor-input type-text one-slot -wo-margin">
                <label for="">Dirección*</label>
                <input type="text" name="direccion" v-model="newuser.direccion" v-validate="'required|min:3'">
            </div>
            <div class="contenedor-input type-text one-slot -wo-margin">
                <label for="">{{ $t('registro.cp') }}*</label>
                <input type="text" name="cp" v-model="newuser.cp" v-validate="'required|numeric|min:5'"
                    autocomplete="nope">
                <span class='error'>{{ errors.first('cp') }}</span>
            </div>
            <div class="contenedor-input type-text one-slot">
                <label for="">{{ $t('oferta.pais') }}*</label>
                <select name="pais" v-model="newuser.idPais" v-if="!!paises" v-validate="'required'">
                    <option value="">-Seleccionar-</option>
                    <option v-if="!!dominios" v-for="(el, key) in paises" :value="Number(el[0])">{{ el[1] }}</option>
                </select>
            </div>
            <div class="contenedor-input type-text one-slot">
                <label for="">{{ $t('oferta.provincia') }}*</label>
                <input type="text" name="provincia" v-model="newuser.provincia" v-if="newuser.idPais != 1"
                    v-validate="'required|min:3'">
                <select name="provincia" v-model="newuser.provincia" v-else v-validate="'required'">
                    <option value="">-Selecciona una provincia-</option>
                    <option v-if="!!dominios" v-for="(el, key) in provincias" :value="Number(el[0])">{{ el[1] }}
                    </option>
                </select>
                <span class='error'>{{ errors.first('provincia') }}</span>
            </div>
            <div class="contenedor-input one-slot">
                <label for="">Localidad*</label>
                <select name="localidad" v-model="newuser.idLocalidad"
                    v-if="newuser.idPais == '1' && brand.localidadesEnDominios" v-validate="'required'">
                    <option value="">{{ $t('registro.selecciona_localidad') }}</option>
                    <option v-if="!!dominios" v-for="(el, key) in localidadesfilter(newuser.provincia)"
                        :value="el.idLocalidad">
                        {{ el.descripcion }}
                    </option>
                </select>
                <input type="text" name="localidad" v-model="newuser.localidad" v-else v-validate="'required|min:3'">
                <span class='error'>{{ errors.first('localidad') }}</span>
            </div>
            <div class="contenedor-input  row-start">
                <span class="btn -solid-primary mb-0" @click="validateContacto">{{ $t('guardar') }}</span>
            </div>
        </form>
        <!-- 
        <div class="contenedor-input type-text one-slot">
            <label for="">{{ $t('registro.nombre') }}*</label>
            <input type="text" v-validate="'required|min:3|max:150'" name="nombreUsuario" v-model="newuser.nombre">
            <span class='error'>{{ errors.first('nombreUsuario') }}</span>
        </div>

        <div class="contenedor-input type-text one-slot">
            <label for="">{{ $t('registro.apellidos') }}*</label>
            <input type="text" v-validate="'required|min:3|max:150'" name="apellidosUsuario"
                v-model="newuser.apellidos">
            <span class='error'>{{ errors.first('apellidosUsuario') }}</span>
        </div>


        <div :class="['contenedor-input row-start type-text three-slot']" v-if="brand.requestTipoContacto">
            <label for="">{{ $t('registro.tipo_contacto') }}*</label>

            <template v-if="!!dominiosOrder && !!dominiosOrder.tiposContacoEmpresa">
                <div class="radio-container" v-for="(tipo, key) in dominiosOrder.tiposContacoEmpresa">
                    <input type="checkbox" :value="tipo[0]" :id="'tipo-contacto-' + tipo[0]"
                        v-model="newuser.tipoContacto" name="tipocontactoUsuario">
                    <label :for="'tipo-contacto-' + tipo[0]">{{ tipo[1] }}</label>
                </div>
            </template>
            <span class='error'>{{ errors.first('tipocontactoUsuario') }}</span>
        </div>

        <div class="contenedor-input type-text one-slot">
            <label for="">{{ $t('registro.email') }}*</label>
            <input type="text" v-validate="'email|required'" name="emailUsuario" v-model="newuser.email">
            <span class='error'>{{ errors.first('emailUsuario') }}</span>
        </div>

        <div class="contenedor-input type-text one-slot">
            <label for="">{{ $t('registro.telefono_1') }}*</label>
            <input type="text" v-validate="'required|min:9'" name="telefonoUsuario" v-model="newuser.telefono1">
            <span class='error'>{{ errors.first('telefonoUsuario') }}</span>
        </div>

        <div class="contenedor-input type-text one-slot">
            <label for="">{{ $t('registro.telefono_2') }}</label>
            <input type="text" v-validate="'min:9'" name="telefono2Usuario" v-model="newuser.telefono2">
            <span class='error'>{{ errors.first('telefono2Usuario') }}</span>
        </div>


        <div class="contenedor-input type-text one-slot">
            <label for="">{{ $t('registro.cargo') }}*</label>
            <input type="text" autocomplete="none" v-validate="'required|min:3|max:150'" name="cargoUsuario"
                v-model="newuser.puesto">
            <span class='error'>{{ errors.first('cargoUsuario') }}</span>
        </div>

        <div class="contenedor-input type-text two-slot">
            <label for="">{{ $t('registro.direccion') }}*</label>
            <input type="text" v-validate="'required|min:3|max:150'" name="direccionUsuario"
                v-model="newuser.direccion">
            <span class='error'>{{ errors.first('direccionUsuario') }}</span>
        </div>

        <div class="contenedor-input type-text one-slot">
            <label for="">{{ $t('registro.localidad') }}*</label>
            <input type="text" v-validate="'required|min:3|max:150'" name="localidadUsuario"
                v-model="newuser.localidad">
            <span class='error'>{{ errors.first('localidadUsuario') }}</span>
        </div>

        <div class="contenedor-input type-text one-slot">
            <label for="">{{ $t('registro.cp') }}*</label>
            <input type="text" v-validate="'required|min:3|max:150'" name="cpUsuario" v-model="newuser.cp">
            <span class='error'>{{ errors.first('cpUsuario') }}</span>
        </div>

        <div class="contenedor-botones row-start">
            <a class="btn -solid-primary" :loading="loading">{{ $t('registro.anadir_contacto')
                }}</a>
            <a class="btn -skull-primary" @click="$emit('close')">{{ $t('cancelar') }}</a>
        </div> -->


    </div>

</template>

<script lang="js">

import Datepicker from 'vuejs-datepicker';

import { ca, es } from 'vuejs-datepicker/dist/locale';

import Vue from 'vue';
import VeeValidate from 'vee-validate';
Vue.use(VeeValidate);

import { mapGetters, mapActions } from 'vuex';

import { Validator } from 'vee-validate';


Validator.extend('checkdni', {
    validate: value => {
        var validChars = 'TRWAGMYFPDXBNJZSQVHLCKET';
        var nifRexp = /^[0-9]{8}[TRWAGMYFPDXBNJZSQVHLCKET]{1}$/i;
        var nieRexp = /^[XYZ]{1}[0-9]{7}[TRWAGMYFPDXBNJZSQVHLCKET]{1}$/i;
        var str = value.toString().toUpperCase();

        if (!nifRexp.test(str) && !nieRexp.test(str)) return false;

        var nie = str
            .replace(/^[X]/, '0')
            .replace(/^[Y]/, '1')
            .replace(/^[Z]/, '2');

        var letter = str.substr(-1);
        var charIndex = parseInt(nie.substr(0, 8)) % 23;

        if (validChars.charAt(charIndex) === letter) return true;

        return false;
    },
    getMessage: field => 'El campo DNI está mal formado',
});

export default {
    name: 'add-contacto',
    props: ['contactData'],
    data() {
        return {
            newuser: {
                "nombre": "",
                "apellidos": "",
                "puesto": "",
                "email": "",
                "nick": "",
                "telefono1": "",
                "telefono2": "",
                "password": "",
                "departamento": "",
                "localidad": "",
                "idLocalidad": '',
                "direccion": "",
                "cp": "",
                "nif": "",
                "idPais": '',
                "provincia": "",
                "tipoContacto": [""],
                "aniosForoEmpleo": "",
                "show": false
            },
            ca: ca,
            es: es,
            loading: false,
            isEdition: false
        }
    },
    mounted() {
        if (!!this.contactData) {
            this.isEdition = true;
            this.requestContactoById({ id: this.contactData.idContacto }).then((res) => {
                this.newuser = res;
            }).catch((error) => console.log(error))
        }
    },
    computed: {
        ...mapGetters({
            dominios: 'getDominios',
            dominiosOrder: 'getDominiosOrder',
            brand: 'getBrand',
            tiposContacto: 'getTipoContactoEmpresa',
            paises: 'getPaises',
            provincias: 'getProvincias'
        }),
    },
    methods: {
        ...mapActions(['addContactoEmpresa', 'requestContactoById']),
        validateContacto() {
            this.$validator.validateAll('formContact')
                .then(itsOk => {
                    if (itsOk) {
                        this.loading = true;
                        this.addContactoEmpresa(this.newuser).then(r => {
                            if (r) {
                                this.$emit('added');
                            }
                            this.loading = false;
                        });
                    }
                });
        }
    }
}
</script>

<style scoped lang="scss">
.box-gray-content form .contenedor-input {
    padding-bottom: 0;
}

@media screen and (max-width: 900px) {
    p {
        margin-left: 0;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/views/documentacion/addContacto.vue